export const environment = {
  production: false,
  baseUri: 'https://scout-test.scoular.com',
  clientId: '496fcbd4-c4c8-4bae-8d27-2b1a99d55d43',
  authScope: 'api://bf72e82d-d530-4dc2-ac83-f1718ca4d8f6/ScouT.Application.QA',
  loginUrl: 'https://login.microsoftonline.com/1521f999-f722-4a4f-9747-166f93e9b0d1'
};
